import { CognitoUser, CognitoUserSession } from 'amazon-cognito-identity-js';
import { GcalClient } from '.';

export type GcalUser = CognitoUser;
export type GcalSession = CognitoUserSession;
export type UserAttributes = Record<string, string>;

export interface ISignInInfo {
  refreshToken: string;
  username: string;
}

export enum GcalStatus {
  STARTUP,
  AUTHENTICATED,
  UNAUTHENTICATED,
}

/**
 * GCAL Context
 */
export interface IGcalContext {
  client: GcalClient | null;
  user: GcalUser | null;
  attributes?: UserAttributes;
  groups?: string[];
  status: GcalStatus;
  error?: Error;
  signIn: (info: ISignInInfo) => Promise<void>;
  signOut: (redirect?: string) => void;
  getSession: () => Promise<GcalSession>;
}
